// material-ui
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Grow from "@mui/material/Grow";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import MuiSnackbar from "@mui/material/Snackbar";

// project-imports
import IconButton from "./IconButton";
import { closeSnackbar, useGetSnackbar } from "api/snackbar";

// assets
import { X } from "lucide-react";

function TransitionSlideLeft(props) {
  return <Slide {...props} direction="left" />;
}

function TransitionSlideUp(props) {
  return <Slide {...props} direction="up" />;
}

function TransitionSlideRight(props) {
  return <Slide {...props} direction="right" />;
}

function TransitionSlideDown(props) {
  return <Slide {...props} direction="down" />;
}

function GrowTransition(props) {
  return <Grow {...props} />;
}

const animation = {
  SlideLeft: TransitionSlideLeft,
  SlideUp: TransitionSlideUp,
  SlideRight: TransitionSlideRight,
  SlideDown: TransitionSlideDown,
  Grow: GrowTransition,
  Fade,
};

function CloseButton({ onClick }) {
  return (
    <IconButton
      size="small"
      aria-label="Fermer"
      color="inherit"
      onClick={onClick}
      sx={{ borderRadius: 'var(--brand-radius-md)'}}
    >
      <X size={16} strokeWidth={1.75} />
    </IconButton>
  );
}

// ==============================|| SNACKBAR ||============================== //

export default function Snackbar() {
  const { snackbar } = useGetSnackbar();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    closeSnackbar();
  };

  if (!snackbar) {
    return null;
  }

  const Transition = animation[snackbar.transition] || TransitionSlideLeft;
  const showClose = snackbar.close !== false;
  const showAction = snackbar.actionButton === true;

  return (
    <>
      {snackbar.variant === "default" && (
        <MuiSnackbar
          anchorOrigin={snackbar.anchorOrigin}
          open={snackbar.open}
          autoHideDuration={snackbar.autoHideDuration}
          onClose={handleClose}
          message={snackbar.message}
          TransitionComponent={Transition}
          action={
            <>
              {showAction && (
                <Button color="secondary" size="small" onClick={handleClose}>
                  Annuler
                </Button>
              )}
              {showClose && <CloseButton onClick={handleClose} />}
            </>
          }
        />
      )}

      {snackbar.variant === "alert" && (
        <MuiSnackbar
          TransitionComponent={Transition}
          anchorOrigin={snackbar.anchorOrigin}
          open={snackbar.open}
          autoHideDuration={snackbar.autoHideDuration}
          onClose={handleClose}
        >
          <Alert
            variant={snackbar.alert?.variant || "standard"}
            color={snackbar.alert?.color}
            icon={false}
            action={
              <Stack direction="row" alignItems="center" spacing={0.5}>
                {showAction && (
                  <Button
                    color={snackbar.alert?.color}
                    size="small"
                    onClick={handleClose}
                  >
                    Annuler
                  </Button>
                )}
                {showClose && <CloseButton onClick={handleClose} />}
              </Stack>
            }
            sx={snackbar.alert?.sx}
          >
            {snackbar.message}
          </Alert>
        </MuiSnackbar>
      )}
    </>
  );
}
